/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useCallback } from 'react';

import { reportingTreeStore } from '@stores/reportingTreeStore';
import type { TreeViewInterface } from '@stores/reportingTreeStore/toViewModel';

import { ContentMenu } from '../../ReportingForms/ContentMenu';
import { PackageStatus } from '../PackageStatus';
import { openInNewTab } from './openInNewTab';

import styles from '../ReportingTree.module.scss';

// Функция для подсветки значения по поиску
export const useMark = (): any => {
  const { stateTree } = reportingTreeStore;

  return useCallback(
    (treeData: TreeViewInterface[]) => {
      const loop = (out: TreeViewInterface[]): any[] =>
        out.map((item: TreeViewInterface) => {
          let title = (
            <span data-package={item.reportPackageCode} data-version={item.reportVersionCode} data-code={item.code}>
              {item.title}
            </span>
          );

          if (stateTree.searchValue) {
            const index = item.title.toLowerCase().indexOf(stateTree.searchValue.toLowerCase());

            const beforeStr = item.title.substr(0, index);
            const str = item.title.substr(index, stateTree.searchValue.length);
            const afterStr = item.title.substr(index + stateTree.searchValue.length);

            if (index > -1)
              title = (
                <span data-package={item.reportPackageCode} data-version={item.reportVersionCode} data-code={item.code}>
                  {beforeStr}
                  <span className={styles.searchValue}>{str}</span>
                  {afterStr}
                </span>
              );
          }

          if (item.reportPackageCode && !item.reportVersionCode) {
            title = <PackageStatus title={title} status={item.reportPackageStatus ?? ''} />;
          }

          if (item.reportVersionCode) {
            title = (
              <ContentMenu onClick={() => openInNewTab(treeData, item)} fromTree>
                {title}
              </ContentMenu>
            );
          }

          if (item.children) {
            return { ...item, title, key: item.key, children: loop(item.children) };
          }

          return {
            ...item,
            title,
          };
        });

      return loop(treeData);
    },
    [stateTree.searchValue],
  );
};
